var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultClock = function SvgDefaultClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.52 0 10 4.474 10 10s-4.48 10-10 10S0 15.526 0 10 4.48 0 10 0m0 1.466C5.27 1.466 1.442 5.29 1.442 10S5.271 18.534 10 18.534c4.73 0 8.558-3.823 8.558-8.534 0-4.71-3.828-8.534-8.558-8.534m.625 3.172v5.885h2.689v1.25H9.375V4.638z"
  })));
};
export default SvgDefaultClock;